import React from "react";
import Vehicles from "@/pages/Vehicles";

// Sprint UI-GLOBALE — il menu WEB usa la lista Veicoli (colonne personalizzabili, filtri) con i flag di canale.
export default function Web() {
  return <Vehicles mode="web" />;
}
